//export const BASE_URL = "https://clus.harpy.yomastrategic.net" // SANDBOX
  export const BASE_URL = "https://clus.phoenix.yomastrategic.net"

export const LOGIN =  `${BASE_URL}/users/login`
export const AVAILABLE_ROOM = `${BASE_URL}/units/available`
export const SUBMIT_UNIT = `${BASE_URL}/bookings/confirm`
export const SUBMIT_CONTACT = `${BASE_URL}/enquiries/add`

 export const OWNER= "https://www.cityloftyangon.com/owner"; // LIVE
//export const OWNER = "https://clus.harpy.yomagroup.io/owner"; // SANDBOX